import React, { FC, useEffect, useState } from 'react'

import { getPasswordRuleStatuses, PASSWORD_RULES_HINT_ITEMS } from '../../../utils/ant-form-validators'
import { Accept, Close } from '../icons'
import styles from './password-rules-hint.module.scss'

type Props = {
  value?: string
  fieldHint?: boolean
  visible?: boolean
}

const PasswordRulesHint: FC<Props> = ({ value = '', fieldHint = false, visible = true }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!fieldHint) {
      return
    }

    const animationFrame = window.requestAnimationFrame(() => {
      setIsVisible(visible)
    })

    return () => window.cancelAnimationFrame(animationFrame)
  }, [fieldHint, visible])

  if (!fieldHint) {
    return (
      <div className={styles.root}>
        <div className={styles.title}>Требования к паролю:</div>
        <ul className={styles.tooltipList}>
          {PASSWORD_RULES_HINT_ITEMS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    )
  }

  const className = [styles.root, styles.fieldHint, !isVisible ? styles.hidden : ''].join(' ')

  return (
    <div className={className}>
      <ul className={styles.list}>
        {getPasswordRuleStatuses(value).map((item) => (
          <li key={item.label} className={item.isValid ? styles.valid : styles.invalid}>
            <span className={styles.icon}>
              {item.isValid ? <Accept size={16} color="currentColor" /> : <Close size={16} color="currentColor" />}
            </span>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default PasswordRulesHint
